<div class="col-12 pl-0 pr-0 mb-">
    <p-accordion [activeIndex]="visible?0:1">
        <p-accordionTab header="{{ heading }}">
            <div class="p-fluid grid">
                <div class="field col-12 sm:col-12 xl:col-4 lg:col-6 md:col-12 mb-0 pb-0">
                    <!--<div class="field col-12 md:col-4  mb-0 pb-0">-->
                    <div class="card basic h-12rem pt-0 pb-0 pl-0 pr-0"
                         [ngClass]="{ 'expired-background': ptDetails?.isExpired == '1' }">
                        <div style="float: left !important; background: #d9d9d9; border-radius: 5px !important; max-width: 7rem; min-width: 4rem; height: 100% ">
                            <div style="border-radius: 1rem !important">
                                <img class="profile-image" src="{{ imagesource }}" style="padding-top: 43%; border-radius: 50%; max-width: 7rem; min-width: 4rem;" />
                            </div>
                        </div>
                        <div>
                            <div class="flex card-header mb-0">

                                <div class="flex p-grid card-header col-8 mt-3 Darkblue w-8 mb-3"
                                     style="color: snow; padding: 7px 7px"
                                     [ngClass]="{
                      'expired-headercolor': ptDetails?.isExpired == '1',
                    }">
                                    <div class="flex p-col-9 pl-2" *ngIf="ptdemographics?.fullName">
                                        <h5>{{ ptDetails?.fullName }}</h5>
                                    </div>
                                </div>
                                <div class="flex pl-2">
                                    <!--<span *ngIf="ptDetails?.isExpired == '1'">
                                        <img src="../../../../assets/imagesNew/Corpse.png"
                                             width="29"
                                             height="29" />
                                    </span>-->


                                </div>
                                <span class="flex mr-3" *ngIf="ptDetails?.isSmoker == '1'">

                                    <img src="../../../../assets/imagesNew/Smoker1.png"
                                         width="29"
                                         height="29" />
                                </span>

                                <span class="flex mr-3" (click)="updatePatientDetails()" *ngIf="isUpdateDemographic">
                                    <!--<img src="../../../../assets/imagesNew/Smoker1.png"
                                         width="29"
                                         height="29" />-->

                                    <button pButton type="button" icon="pi pi-pencil" pTooltip="Edit Demographics" class="p-button-rounded p-button-text"></button>
                                </span>
                            </div>
                        </div>


                        <div class="flex flex-column pl-3">
                            <div class="flex align-items-center mb-1"
                                 *ngIf="ptdemographics?.gender">
                                <span class="font-semibold mr-1 text-900 pr-1">GENDER:</span><span>{{ ptDetails?.gender }}</span>
                            </div>
                            <div class="flex align-items-center mb-1"
                                 *ngIf="ptdemographics?.mrn">
                                <span class="font-semibold mr-1 text-900 pr-4">MRN:</span><span class="pl-1">{{ ptDetails?.mrn }}</span>
                            </div>
                            <div class="flex align-items-center mb-1"
                                 *ngIf="ptdemographics?.dob">
                                <span class="font-semibold mr-1 text-900 pr-4">D.O.B:</span><span>{{ ptDetails?.shortDOB }}</span>
                            </div>

                            <div class="flex align-items-center mb-1" *ngIf="ptdemographics?.age">
                                <span class="font-semibold mr-1 text-900 pr-5">AGE:</span><span>{{ ptDetails?.age }}</span>
                            </div>
                        </div>
                    </div>
                </div>







                <div class="field col-12 sm:col-12 xl:col-4 lg:col-6 md:col-12 mb-0 pb-0">
                    <!--<div class="field col-12 md:col-4 mb-0 pb-0">-->
                    <div class="card pro-plus h-12rem" [ngClass]="{ 'expired-background': ptDetails?.isExpired == '1' }">
                        <div class="card-header mb-0">
                            <div class="p-grid card-header w-8 Darkblue"
                                 style="color: snow; border-radius: 10px; padding: 7px 7px" [ngClass]="{'expired-headercolor': ptDetails?.isExpired == '1',}">
                                <div class="p-col-12">
                                    <h5>Contact Information</h5>
                                </div>
                            </div>
                            <!--<img src="../../../../assets/imagesNew/Flip.png"    width="26"    height="22"    class="mb-3"  (click)="otherContactDetailToggle()" title="click to view other details" />-->
                        </div>
                        <div class="card-content" *ngIf="!isotherContactDetails">
                            <div class="flex">
                                <div class="flex flex-column text-wrap">

                                    <div class="flex  align-items-center mb-1"
                                         *ngIf="ptdemographics?.address">
                                        <span class="font-semibold mr-3 text-900 pb-3 pr-2">ADDRESS:</span><span [innerHtml]="ptDetails?.address"></span>
                                    </div>



                                    <div class="flex  align-items-center mb-0 text-wrap"
                                         *ngIf="ptdemographics?.workPhone || ptdemographics?.mobilePhone || ptdemographics?.homePhone">

                                        <span class="font-semibold mr-5 text-900 pb-3 pr-2">PHONE:</span><span class="contact-padding text-wrap" [innerHtml]="ptDetails?.phoneCombinedStr"></span>

                                    </div>
                                    <!--<div class="flex align-items-center mb-3">

                                        <span class="font-semibold mr-1 text-900" *ngIf="ptdemographics?.workPhone || ptdemographics?.mobilePhone || ptdemographics?.homePhone">PHONE</span>
                                        &nbsp;<span class="font-semibold mr-1 text-900" *ngIf="ptdemographics?.workPhone">(W):</span>

                                        <span *ngIf="ptdemographics?.workPhone">{{ ptDetails?.officePhone }} &nbsp;</span>
                                        <span class="font-semibold text-900" *ngIf="ptdemographics?.mobilePhone">(M):</span>
                                        <span *ngIf="ptdemographics?.mobilePhone">{{ ptDetails?.mobileNo }}&nbsp;</span>

                                        <span class="font-semibold mr-1 text-900" *ngIf="ptdemographics?.homePhone">(H):</span>
                                        <span *ngIf="ptdemographics?.homePhone">{{ ptDetails?.homePhone }}</span>
                                    </div>-->
                                    <!--<div class="flex align-items-center mb-3" *ngIf="ptdemographics?.mobileNo">


                                    </div>-->
                                    <!--<div class="flex align-items-center mb-3" *ngIf="ptdemographics?.homePhone">

                                    </div>-->

                                </div>
                            </div>
                        </div>

                        <!--<div class="card-content" *ngIf="isotherContactDetails">
                            <div class="flex">
                                <div class="flex flex-column">
                                    <div class="flex justify-content-between align-items-center mb-3" *ngIf="ptdemographics?.address2">
                                        <span class="font-semibold mr-3 text-900 pr-2">ADDRESS2:</span><span [innerHtml]="ptDetails?.fullAddress"></span>
                                    </div>
                                    <div class="flex align-items-center mb-3" *ngIf="ptdemographics?.homePhone">
                                        <span class="font-semibold mr-3 text-900">PHONE(H):</span><span>{{ ptDetails?.homePhone }}</span>
                                    </div>


                                </div>
                                </div>

                            </div>-->
                    </div>
                </div>

                <div class="field col-12 sm:col-12 xl:col-4 lg:col-6 md:col-12 mb-0 pb-0">
                    <!--<div class="field col-12 md:col-4 mb-0 pb-0">-->
                    <div class="card pro-plus h-12rem" [ngClass]="{ 'expired-background': ptDetails?.isExpired == '1' }">
                        <div class="card-header mb-0">
                            <div class="p-grid card-header w-8 Darkblue"
                                 style="color: snow; border-radius: 10px; padding: 7px 7px"
                                 [ngClass]="{'expired-headercolor': ptDetails?.isExpired == '1'}">
                                <div class="p-col-12">
                                    <h5>Other Information</h5>
                                </div>
                            </div>

                            <!--<i (click)="editInsurance()" class="pi  pi-pencil mb-3" style="font-size: 4rem"></i>-->
                            <button pButton type="button" icon="pi pi-plus" pTooltip="Create Payer" class="p-button-rounded p-button-text" (click)="editInsurance()"  *ngIf="isAddPayer"></button>
                                             <img src="../../../../assets/imagesNew/Flip.png"  width="26"  height="22"  class="mb-3"  (click)="otherColumsInfoView()" />

                        </div>
                        <div class="card-content" *ngIf="!isotherColums">
                                   <div class="flex">
        <div class="flex flex-column">
            <div class="flex justify-content-left align-items-center mb-3" *ngIf="ptdemographics?.insuranceCompany">
                <span class="font-semibold mr-6 text-900 pr-4">INSURANCE:</span><span>{{ ptDetails?.insuranceCompany }}</span>
            </div>
            <div class="flex justify-content-left align-items-center mb-3" *ngIf="ptdemographics?.pharmacyName">
                <span class="font-semibold mr-3 text-900 pr-1">PHARMACY NAME:</span><span>{{ ptDetails?.pharmacyName }}</span>
            </div>
            <div class="flex justify-content-left align-items-center" *ngIf="ptdemographics?.pharmacyPhone">
                <span class="font-semibold mr-3 text-900">PHARMACY PHONE:</span><span>{{ ptDetails?.pharmacyPhone }}</span>
            </div>
        </div>
      </div>
                        </div>
                        <div class="card-content" *ngIf="isotherColums">
                            <div class="flex">
                                <div class="flex flex-column">
                                    <div class="flex justify-content-between align-items-center mb-3"
                                         *ngFor="let column of otherColumnsArray">
                                        <span class="font-semibold mr-3 text-900">{{ column.name }}:</span><span>{{ column.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </p-accordionTab>
    </p-accordion>

    <p-dialog  header="Create Payor" [(visible)]="showInsurance" [maximizable]="true" *ngIf="showInsurance">
        <app-add-insurance [payers]="(payers |async)?.data" (payerAdded)="newPayerAdded($event)"></app-add-insurance>
    </p-dialog>
</div>


<p-dialog  header="Update Patient Demographics" [(visible)]="isPatientDemographic" modal="false" [style]="{ width: '1000px', minWidth: '200px' }" [resizable]="true">
    <app-patient-demographic (cancel)="closeDialog()"></app-patient-demographic>
</p-dialog>
